export enum UploadTypes {
  DICOMDisk = 'DICOM Disc (medical images)',
  VIDEODisk = 'Video Disc',
  VIDEO = 'Video',
  FILE = 'File'
}
